import { DataLevel, DynamicTurnout, DynamicTurnoutEnte } from './model';

export const getAffluenzaByLivelloPerc = (
  dynamicTurnout: DynamicTurnout[],
  level: DataLevel,
  cod_reg: string | undefined,
  cod_prov: string | undefined,
  cod_com: string | undefined
) => {
  switch (level) {
    case DataLevel.MAIN:
    case DataLevel.REGIONE:
      return getAffluenzaRegionePerc(dynamicTurnout, level, cod_reg);
    case DataLevel.PROVINCIA:
      return getAffluenzaProvinciaPerc(
        dynamicTurnout,
        level,
        cod_reg,
        cod_prov
      );
    case DataLevel.COMUNE:
      return getAffluenzaComunePerc(
        dynamicTurnout,
        level,
        cod_reg,
        cod_prov,
        cod_com
      );
    default:
      return 0;
  }
};

export const getAffluenzaByLivelloVoti = (
  dynamicTurnout: DynamicTurnout[],
  level: DataLevel,
  cod_reg: string | undefined,
  cod_prov: string | undefined,
  cod_com: string | undefined
) => {
  switch (level) {
    case DataLevel.MAIN:
    case DataLevel.REGIONE:
      return getAffluenzaRegioneVoti(dynamicTurnout, level, cod_reg);
    case DataLevel.PROVINCIA:
      return getAffluenzaProvinciaVoti(
        dynamicTurnout,
        level,
        cod_reg,
        cod_prov
      );
    case DataLevel.COMUNE:
      return getAffluenzaComuneVoti(
        dynamicTurnout,
        level,
        cod_reg,
        cod_prov,
        cod_com
      );
    default:
      return 0;
  }
};

export const getAffluenzaByLivelloEleT = (
  dynamicTurnout: DynamicTurnout[],
  level: DataLevel,
  cod_reg: string | undefined,
  cod_prov: string | undefined,
  cod_com: string | undefined
) => {
  switch (level) {
    case DataLevel.MAIN:
    case DataLevel.REGIONE:
      return getAffluenzaRegioneEleT(dynamicTurnout, cod_reg);
    case DataLevel.PROVINCIA:
      return getAffluenzaProvinciaEleT(
        dynamicTurnout,
        level,
        cod_reg,
        cod_prov
      );
    case DataLevel.COMUNE:
      return getAffluenzaComuneEleT(dynamicTurnout, cod_reg, cod_prov, cod_com);
    default:
      return 0;
  }
};

export const getAffluenzaRegionePerc = (
  dynamicTurnout: DynamicTurnout[],
  level: DataLevel,
  cod_reg: string | undefined
) => {
  return getAffluenzaRegione(dynamicTurnout, level, cod_reg)?.perc || '0';
};

export const getAffluenzaRegioneVoti = (
  dynamicTurnout: DynamicTurnout[],
  level: DataLevel,
  cod_reg: string | undefined
) => {
  return getAffluenzaRegione(dynamicTurnout, level, cod_reg)?.vot_t || 0;
};

export const getAffluenzaRegione = (
  dynamicTurnout: DynamicTurnout[],
  level: DataLevel,
  cod_reg: string | undefined
) => {
  let codiceRegione = -1;
  if (cod_reg !== undefined) {
    codiceRegione = +cod_reg;
  }
  let indexCom = getActiveIndexComunicazione(
    dynamicTurnout,
    level,
    codiceRegione
  );
  let levelReg = getLevelReg(dynamicTurnout);
  if (levelReg !== undefined) {
    let comunic = levelReg.enti.enti_f.find(
      (r: DynamicTurnoutEnte) => r.cod === codiceRegione
    )?.com_vot[indexCom];

    if (comunic?.vot_t === 0 && indexCom > 0) {
      indexCom--;
      comunic = levelReg.enti.enti_f.find(
        (r: DynamicTurnoutEnte) => r.cod === codiceRegione
      )?.com_vot[indexCom];
    }
    return comunic;
  }
  return { vot_t: 0, perc: 0 };
};

export const getAffluenzaRegioneEleT = (
  dynamicTurnout: DynamicTurnout[],
  cod_reg: string | undefined
) => {
  let codiceRegione = -1;
  if (cod_reg !== undefined) {
    codiceRegione = +cod_reg;
  }
  let levelReg = getLevelReg(dynamicTurnout);
  if (levelReg !== undefined) {
    return (
      levelReg.enti.enti_f.find(
        (r: DynamicTurnoutEnte) => r.cod === codiceRegione
      )?.ele_t || 0
    );
  }
  return 0;
};

export const getActiveIndexComunicazione = (
  dynamicTurnout: DynamicTurnout[],
  level: DataLevel,
  codiceRegione: number,
  codiceProvincia = 0
) => {
  let levelWithData;
  switch (level) {
    case DataLevel.MAIN:
    case DataLevel.REGIONE:
      levelWithData = getLevelReg(dynamicTurnout);
      break;
    case DataLevel.PROVINCIA:
      levelWithData = getLevelProv(dynamicTurnout, codiceRegione);
      break;
    case DataLevel.COMUNE:
      levelWithData = getLevelComune(
        dynamicTurnout,
        codiceRegione,
        codiceProvincia
      );
      break;
  }

  if (levelWithData !== undefined) {
    const arr = levelWithData.enti.ente_p.com;
    return arr[arr.length - 1]?.com_att - 1 || 0;
  }

  return 0;
};

export const getLevelReg = (dynamicTurnout: DynamicTurnout[]) => {
  return dynamicTurnout?.find(a => 'ITALIA' === a.int.l_terr);
};

// PROV

export const getAffluenzaProvinciaPerc = (
  dynamicTurnout: DynamicTurnout[],
  level: DataLevel,
  cod_reg: string | undefined,
  cod_prov: string | undefined
) => {
  return (
    getAffluenzaProvincia(dynamicTurnout, level, cod_reg, cod_prov)?.perc || '0'
  );
};

export const getAffluenzaProvincia = (
  dynamicTurnout: DynamicTurnout[],
  level: DataLevel,
  cod_reg: string | undefined,
  cod_prov: string | undefined
) => {
  let codiceRegione = -1;
  if (cod_reg !== undefined) {
    codiceRegione = +cod_reg;
  }
  let indexCom = getActiveIndexComunicazione(
    dynamicTurnout,
    level,
    codiceRegione
  );
  let levelProv = getLevelProv(dynamicTurnout, codiceRegione);
  if (levelProv !== undefined) {
    let codiceProvincia = -1;
    if (cod_prov !== undefined) {
      codiceProvincia = +cod_prov;
    }
    let comunic = levelProv.enti.enti_f.find(
      (p: DynamicTurnoutEnte) => p.cod === codiceProvincia
    )?.com_vot[indexCom];

    if (comunic?.vot_t === 0 && indexCom > 0) {
      // read previous comunication
      indexCom--;
      comunic = levelProv.enti.enti_f.find(
        (p: DynamicTurnoutEnte) => p.cod === codiceProvincia
      )?.com_vot[indexCom];
    }
    return comunic;
  }
  return { vot_t: 0, perc: 0, ele_t: 0 };
};

export const getAffluenzaProvinciaVoti = (
  dynamicTurnout: DynamicTurnout[],
  level: DataLevel,
  cod_reg: string | undefined,
  cod_prov: string | undefined
) => {
  return (
    getAffluenzaProvincia(dynamicTurnout, level, cod_reg, cod_prov)?.vot_t || 0
  );
};

export const getAffluenzaProvinciaEleT = (
  dynamicTurnout: DynamicTurnout[],
  level: DataLevel,
  cod_reg: string | undefined,
  cod_prov: string | undefined
) => {
  let codiceRegione = -1;
  if (cod_reg !== undefined) {
    codiceRegione = +cod_reg;
  }
  let levelProv = getLevelProv(dynamicTurnout, codiceRegione);
  if (levelProv !== undefined) {
    let codiceProvincia = -1;
    if (cod_prov !== undefined) {
      codiceProvincia = +cod_prov;
    }
    return (
      levelProv.enti.enti_f.find(
        (p: DynamicTurnoutEnte) => p.cod === codiceProvincia
      )?.ele_t || 0
    );
  }
  return 0;
};

export const getLevelProv = (
  dynamicTurnout: DynamicTurnout[],
  codiceRegione: number
) => {
  return dynamicTurnout?.find(
    a => 'REGIONE' === a.int.l_terr && codiceRegione === a.enti.ente_p.cod
  );
};

// COMUNE

export const getAffluenzaComunePerc = (
  dynamicTurnout: DynamicTurnout[],
  level: DataLevel,
  cod_reg: string | undefined,
  cod_prov: string | undefined,
  cod_com: string | undefined
) => {
  return (
    getAffluenzaComune(dynamicTurnout, level, cod_reg, cod_prov, cod_com)
      ?.perc || '0'
  );
};

export const getAffluenzaComuneVoti = (
  dynamicTurnout: DynamicTurnout[],
  level: DataLevel,
  cod_reg: string | undefined,
  cod_prov: string | undefined,
  cod_com: string | undefined
) => {
  return (
    getAffluenzaComune(dynamicTurnout, level, cod_reg, cod_prov, cod_com)
      ?.vot_t || 0
  );
};

export const getAffluenzaComune = (
  dynamicTurnout: DynamicTurnout[],
  level: DataLevel,
  cod_reg: string | undefined,
  cod_prov: string | undefined,
  cod_com: string | undefined
) => {
  let codiceRegione = -1;
  if (cod_reg !== undefined) {
    codiceRegione = +cod_reg;
  }
  let codiceProvincia = -1;
  if (cod_prov !== undefined) {
    codiceProvincia = +cod_prov;
  }
  let codiceComune = -1;
  if (cod_com !== undefined) {
    codiceComune = +cod_com;
  }
  let indexCom = getActiveIndexComunicazione(
    dynamicTurnout,
    level,
    codiceRegione,
    codiceProvincia
  );
  let levelProv = getLevelComune(
    dynamicTurnout,
    codiceRegione,
    codiceProvincia
  );
  if (levelProv !== undefined) {
    let comunic = levelProv.enti.enti_f.find(
      (p: DynamicTurnoutEnte) => 'COMUNE' === p.tipo && codiceComune === p.cod
    )?.com_vot[indexCom];

    if (comunic?.vot_t === 0 && indexCom > 0) {
      indexCom--;
      comunic = levelProv.enti.enti_f.find(
        (p: DynamicTurnoutEnte) => 'COMUNE' === p.tipo && codiceComune === p.cod
      )?.com_vot[indexCom];
    }

    return comunic;
  }
  return { vot_t: 0, perc: 0, ele_t: 0 };
};

export const getAffluenzaComuneEleT = (
  dynamicTurnout: DynamicTurnout[],
  cod_reg: string | undefined,
  cod_prov: string | undefined,
  cod_com: string | undefined
) => {
  let codiceRegione = -1;
  if (cod_reg !== undefined) {
    codiceRegione = +cod_reg;
  }
  let codiceProvincia = -1;
  if (cod_prov !== undefined) {
    codiceProvincia = +cod_prov;
  }
  let codiceComune = -1;
  if (cod_com !== undefined) {
    codiceComune = +cod_com;
  }
  let levelProv = getLevelComune(
    dynamicTurnout,
    codiceRegione,
    codiceProvincia
  );
  if (levelProv !== undefined) {
    return (
      levelProv.enti.enti_f.find(
        (p: DynamicTurnoutEnte) => 'COMUNE' === p.tipo && codiceComune === p.cod
      )?.ele_t || 0
    );
  }
  return 0;
};

export const getLevelComune = (
  dynamicTurnout: DynamicTurnout[],
  codiceRegione: number,
  codiceProvincia: number
) => {
  return dynamicTurnout?.find(
    a =>
      'PROVINCIA' === a.int.l_terr &&
      codiceRegione === a.enti.ente_p.com[0].cod_reg &&
      codiceProvincia === a.enti.ente_p.cod
  );
};
